import { render, staticRenderFns } from "./MSPMntTable.vue?vue&type=template&id=e99f07dc&"
import script from "./MSPMntTable.vue?vue&type=script&lang=js&"
export * from "./MSPMntTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports